import { SIMARouteType, } from "@earthbrain/sima";
export class IPLine {
    group_number;
    route_number;
    route_name;
    route_type = SIMARouteType.IP_LINE;
    _points;
    constructor(route, surveyPoints) {
        this.group_number = route.groupNumber;
        this.route_number = route.routeNumber;
        this.route_name = route.routeName;
        this._points = route.routeElements.map((r) => {
            const routeCoord = r;
            const surveyPoint = surveyPoints.get(`${routeCoord.point_number}-${routeCoord.point_name}`);
            return surveyPoint;
        });
    }
    get points() {
        return this._points;
    }
}
//# sourceMappingURL=ip-line.js.map